import React, { useCallback, useEffect, useState } from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import * as snackbarActions from "../../../Redux/Actions/SnackbarActions/SnackbarActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PharmacySnackbar from "../../../Utils/Snackbars/SnackbarUtil";
import ReusableDashboardHeader from "../../../Containers/Dasboard/ReusableDashboardHeader";
import { history } from "../../../Helpers/history";
import TextField from "../../../Utils/FormInputs/TextField";
import { Container } from "../../../Utils/styledComponents";
import axios from "axios";
import config from "../../../Helpers/config.json";
import { errorMessages } from "../../../Helpers/ErrorMessages";
import {
  CustomTableCell,
  StickyHeadTable,
} from "../../../Utils/Tables/StickyHeaderTable";
import { LoadingGif } from "../../../Utils/Loader";
import { formatAmount } from "../../../Utils/formatNumbers";
import {
  CustomPagination,
  EnhancedTableToolbar,
  MuiPaper,
} from "../../../Utils/Tables/CustomTable";
import { InvoiceDateFilter } from "../../Invoice/InvoiceDateFilter";
import {
  useExcelReports,
  usePdfReports,
} from "../../Invoice/CustomHooks/useExcelReports";
import { ReusableRouteTabs } from "../../../Utils/Tabs/ReusableTabs";
import { formatDate, formatDateTime } from "../../../Utils/ConvertDate";

const headData = [
  { id: "date", numeric: false, disablePadding: false, label: "Date" },
  {
    id: "customer_name",
    numeric: false,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "invoice_number",
    numeric: false,
    disablePadding: false,
    label: "Invoice#",
  },
    {
    id: "amount_received",
    numeric: false,
    disablePadding: false,
    label: "Amount Received",
  },
    {
    id: "payment_account",
    numeric: false,
    disablePadding: false,
    label: "Payment Account",
  },
    {
    id: "received_by",
    numeric: false,
    disablePadding: false,
    label: "Received By",
  }
];

const DebtorsPaymentsReceived = ({ actions, snackbars, match: { params } }) => {

  const filters = [
    { value: "today", text: "Today" },
    { value: "yesterday", text: "Yesterday" },
    { value: "this_week", text: "This Week" },
    { value: "this_month", text: "This Month" },
    { value: "custom", text: "Custom" },
  ];

  const storage = JSON.parse(sessionStorage.getItem("payments_total_count"));
  const item_count = storage ? storage : 0;
  const count = () => +item_count || 0;
  const [data, setData] = React.useState({ payments: [], loading: "idle", total_payments_received:0 });
  const [submitted, setSubmitted] = React.useState(false);
  const [isSubmitted, setIsSubmitted] = React.useState("idle");
  const [searchValue, setSearchValue] = useState("");
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [date, setDate] = useState({
    start_date: "",
    end_date: "",
    filter_by: "today",
  });
  const { payments, loading, total_payments_received } = data;


  const { filter_by, start_date, end_date } = date;

  const isResolved = isSubmitted === "resolved";

  const retrievePayments = useCallback(
    (from_date, to_date) => {
      const isCustom =
        filter_by === "custom"
          ? { start_date: from_date, end_date: to_date }
          : {};
      setData({ ...data, loading: "pending" });
      axios
        .get(`${config.epharmUrl}/Creport/debtors/payments_received`, {
          params: {
            page_number: activePage,
            search: searchValue,
            time_filter: filter_by,
            ...isCustom,
          },
        })
        .then((res) => {
          const data = res.data;
          const dt = data ? data : {};
          const arr = dt.data ? dt.data : {};

          const page_count = arr.total_records ? arr.total_records : 0;
          const arrData = arr.payments ? arr.payments : [];
          const payments_total = arr.total_payments_received ? arr.total_payments_received : 0;

          const dataArr = arrData.map((item) => ({
            ...item,
            id: item.customer_id,
          }));
          if (activePage === 1) {
            sessionStorage.setItem("payments_total_count", JSON.stringify(page_count));
            setTotalPageCount(page_count);
          } else {
            setTotalPageCount(count);
          }
          setData({ payments: dataArr, loading: "success", total_payments_received: payments_total });
        })
        .catch((err) => {
          errorMessages(err, null, actions);
          setData({ ...data, loading: "error" });
        });
    },
    [activePage, searchValue, filter_by]
  );

  useEffect(() => {
    if (filter_by === "custom" && !isResolved) {
      return;
    }
    retrievePayments(start_date, end_date);
  }, [retrievePayments]);

  const handleChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDate({ ...date, [name]: value });
    setIsSubmitted("idle");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (start_date && end_date && start_date < end_date) {
      setIsSubmitted("resolved");
      retrievePayments(start_date, end_date);
    }
  };

  const closeSnackbar = () => {
    actions.snackbarActions.hideSnackBar();
  };

  const isLoading = loading === "pending";
  const isSuccess = loading === "success";
  const isError = loading === "error";

  const { open, variant, message } = snackbars;
  const emptyRows = 10 - Math.min(10, payments.length);

  const pagination = (
    <CustomPagination
      data={payments}
      records={10}
      activePage={activePage}
      total_count={totalPageCount}
      handleChangeNextPage={handlePageChange}
    />
  );

  const currentObj = {
    file_name: "Payments_Received_Report",
    url: "Creport/debtors/payments_received_download",
    params: {
      file_type: 1,
      download: true,
      start_date,
      end_date,
      time_filter: filter_by,
    },
  };

  const { exportExcel } = useExcelReports(actions, currentObj);

  const { exportPDF } = usePdfReports(actions, {
    url: "Creport/debtors/payments_received_download",
    file_name: "Payments_Received_Report",
    params: {
      file_type: 2,
      download: true,
      start_date,
      end_date,
      time_filter: filter_by,
      donwload: true,
    },
  });

    const components = [
    { label: "Customers", path: "/accounting/debtors/customer" },
    { label: "Payments Received", path: "/debtors/payments-received" },
  ];

  return (
    <div>
      <ReusableDashboardHeader
        component="Debtors"
        heading="Debtors"
        subHeading="Payments Received"
        link={history.location.pathname}
      />
      <Container>
        <div className="mb-3">
          <ReusableRouteTabs
            value={history.location.pathname}
            tabHeading={components}
          />
        </div>
        <PharmacySnackbar
          open={open}
          message={message}
          variant={variant}
          handleCloseBar={closeSnackbar}
        />
        <InvoiceDateFilter
          {...{
            filters,
            date,
            handleChange,
            handleFilter: handleSubmit,
            submitted,
          }}
        />
        <MuiPaper>
          <EnhancedTableToolbar>
            <span>
              <button
                className="btn btn-sm pharmacy-btn mr-4"
                onClick={exportExcel}
                data-testid="excel-button"
              >
                Excel
              </button>
            </span>
            <span>
              <button
                className="btn btn-sm pharmacy-info-btn mr-4"
                onClick={exportPDF}
                data-testid="pdf-button"
              >
                Pdf
              </button>
            </span>
            <TextField
              type="text"
              placeholder="search..."
              value={searchValue}
              onChange={handleChangeSearch}
              data-testid="search_list"
            />
          </EnhancedTableToolbar>
            <div className="sub-journal-bar" style={{ marginLeft: "0" }}>
                <h6 data-testid="total_receipts">
                Total Payments Received : <strong>{formatAmount(total_payments_received)}</strong>
                </h6>
            </div>
          <StickyHeadTable
            {...{
              width: "100%",
              data: payments,
              columns: headData.filter((item) => Boolean(item)),
              testId: "debtors-payments-table",
            }}
          >
            {isLoading ? (
              <TableRow>
                <TableCell align="center" {...{ colSpan: headData.length }}>
                  <LoadingGif />
                </TableCell>
              </TableRow>
            ) : null}
            {isSuccess ? (
              payments.length > 0 ? (
                <>
                  {payments.map((row, index) => {
                    return (
                      <TableRow tabIndex={-1} key={index}>
                        <CustomTableCell data-testid={`payment_date-${index}`}>
                          {formatDate(row.payment_date)}
                        </CustomTableCell>
                        <CustomTableCell data-testid={`customer_name-${index}`}>
                            {row.customer_name}
                        </CustomTableCell>
                         <CustomTableCell data-testid={`invoice_number-${index}`}>
                            {row.invoice_number}
                        </CustomTableCell>
                         <CustomTableCell data-testid={`amount_received-${index}`}>
                            {row.paid_amount
                              ? formatAmount(row.paid_amount)
                              : row.paid_amount}
                        </CustomTableCell>
                         <CustomTableCell data-testid={`payment_type-${index}`}>
                            {row.payment_account}
                        </CustomTableCell>
                         <CustomTableCell data-testid={`received_by-${index}`}>
                            {row.received_by}
                        </CustomTableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && totalPageCount <= 0 && (
                    <TableRow style={{ height: 43 * emptyRows }}>
                      <TableCell colSpan={headData.length} />
                    </TableRow>
                  )}
                </>
              ) : (
                <TableRow>
                  <TableCell align="center" {...{ colSpan: headData.length }}>
                    No records found
                  </TableCell>
                </TableRow>
              )
            ) : null}
            {isError ? (
              <TableRow>
                <TableCell align="center" {...{ colSpan: headData.length }}>
                  The server did not return a valid response
                </TableCell>
              </TableRow>
            ) : null}
          </StickyHeadTable>
          {totalPageCount > 0 ? pagination : null}
        </MuiPaper>
      </Container>
    </div>
  );
};

function mapStateToProps(state) {
  return { snackbars: state.snackbars };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DebtorsPaymentsReceived);
